var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File_icon",
    "data-name": "File icon",
    transform: "translate(-445 -678.095)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_389",
    "data-name": "Ellipse 389",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(445 678.095)",
    fill: "#004cff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-copy-3029269",
    transform: "translate(448.837 683.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34564",
    "data-name": "Path 34564",
    d: "M14.507,2.958v.749H8.981A2.322,2.322,0,0,0,6.659,6.029v9.358H5.428a.958.958,0,0,1-.958-.958V2.958A.958.958,0,0,1,5.428,2h8.127A.958.958,0,0,1,14.507,2.958Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34565",
    "data-name": "Path 34565",
    d: "M19.116,6.94H11.4A1.161,1.161,0,0,0,10.24,8.1V19.166A1.161,1.161,0,0,0,11.4,20.327h7.715a1.161,1.161,0,0,0,1.161-1.161V8.1A1.161,1.161,0,0,0,19.116,6.94Zm-.888,9.666H12.272a.581.581,0,0,1,0-1.161h5.956a.581.581,0,1,1,0,1.161Zm0-2.392H12.272a.581.581,0,0,1,0-1.161h5.956a.581.581,0,1,1,0,1.161Zm0-2.392H12.272a.581.581,0,0,1,0-1.161h5.956a.581.581,0,1,1,0,1.161Z",
    transform: "translate(-2.42 -2.072)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileicon);
export default __webpack_public_path__ + "static/media/File icon.7991b419f86731dde725644c981c9587.svg";
export { ForwardRef as ReactComponent };